import { useNetworkStore } from "@/composables/network/useNetwork";
import { OfflineError } from "@/utils/errors";

const rejectInOfflineMode = () => {
  if (useNetworkStore().isOfflineMode) throw new OfflineError();
};

const markServerReached = () => useNetworkStore().markServerReached();

export const blockAxiosInOfflineMode = (client) => {
  client.interceptors.request.use((config) => {
    rejectInOfflineMode();
    return config;
  });
  client.interceptors.response.use(
    (response) => {
      markServerReached();
      return response;
    },
    (error) => {
      if (error?.response) markServerReached();
      throw error;
    }
  );
};

export const offlineModeMiddleware = {
  pre: rejectInOfflineMode,
  post: markServerReached,
};
